// eslint-disable-next-line import/no-anonymous-default-export
export default {
    question: '问题',
    remind: '提醒',
    ques_recommend: '常见问题推荐',
    ques_ans:'反馈问题的进度:',
    order_num: '工单编号',
    response: '回复内容',
    user_ask: '如需进行回复',
    click_here: '点击这里',
    other_qus: '其它问题',
    success_help: '很高兴可以帮到您呢，祝生活愉快。',
    error_help: '很抱歉没有帮到您呢，点击下方按钮可以快速反馈问题，我们会尽快为您解决。',
    satisfaction: '满意',
    unSatisfaction: '不满意',
    return_ask: '反馈问题',
    '超出最大文案120字': '超出最大文案120字',
    '很抱歉，暂时没有内容推荐': '很抱歉，暂时没有内容推荐',
    '请输入您想咨询的问题': '请输入您想咨询的问题',
    '当前网络状态不佳，请稍后再试': '当前网络状态不佳，请稍后再试',
    '客服中心':'客服中心'
}